module.exports = __webpack_public_path__ + "static/media/empty-open.0fe60a26.svg";